import { render } from "./datadog.vue?vue&type=template&id=e5ab52fa"
import script from "./datadog.vue?vue&type=script&lang=js"
export * from "./datadog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__